import * as S from './BulkOverrideWarningDialog.styles.js'
import useScreenSize from '../../../hooks/useScreenSize'
import { GrowTransition } from '../../../components/Transitions/Transitions'
import { translateManager as t } from '../../../services/TranslateManager'
import { getCustomizationDisplayKey } from '../tileCustomization.consts'

export default function BulkOverrideWarningDialog({
  open,
  ctaText,
  onApproved,
  onDismiss,
  customization,
}) {
  const isLargeScreen = useScreenSize('lg')

  function handleApproveClick() {
    onApproved()
    onDismiss()
  }

  const Content = (
    <>
      <S.Title>
        {t.get('designer.bulk_override_warning.title', {
          style: t.get(`designer.${getCustomizationDisplayKey(customization)}`),
        })}
      </S.Title>
      <S.ApplyButton
        testId="bulk-override-warning-approve"
        onClick={handleApproveClick}
      >
        {ctaText}
      </S.ApplyButton>
      <S.DiscardLinkButton
        data-testid="bulk-override-warning-dismiss"
        onClick={onDismiss}
      >
        {t.get('general.discard_changes')}
      </S.DiscardLinkButton>
    </>
  )

  if (isLargeScreen) {
    return (
      <S.Dialog
        open={open}
        onClose={onDismiss}
        TransitionComponent={GrowTransition}
      >
        {Content}
      </S.Dialog>
    )
  } else {
    return (
      <S.Drawer anchor="bottom" open={open} onClose={onDismiss}>
        {Content}
      </S.Drawer>
    )
  }
}
